import styled from 'styled-components';
import { PriceFilterInput } from 'modals/ShiftModal/components/PriceFilterInput';

export const PriceFilter = styled(PriceFilterInput)`
  margin-left: 8px;
`;
